import { render, staticRenderFns } from "./userAvatar.vue?vue&type=template&id=31b3da3b&scoped=true&"
import script from "./userAvatar.vue?vue&type=script&lang=ts&"
export * from "./userAvatar.vue?vue&type=script&lang=ts&"
import style0 from "./userAvatar.vue?vue&type=style&index=0&id=31b3da3b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b3da3b",
  null
  
)

export default component.exports